import initRum from '@fastnorth/datadog/initRum';
import { isAnalyticalAllowed } from '@fastnorth/kraken/components/cookie-consent';
import { KEYS, SERVICE_NAMES } from './config/constants';
import getEnvFromHostname from './utils/getEnvFromHostname';

initRum({
  applicationId: KEYS.dataDogRUMApplicationId,
  clientToken: KEYS.dataDogRUMClientToken,
  service: SERVICE_NAMES.dataDogRUM,
  applicationVersion: import.meta.env.VERSION,
  env: getEnvFromHostname(),
  shouldInit: isAnalyticalAllowed,
  allowedTracingUrls: [
    'https://results.raceroster.com',
    'https://results.ue1dev1.rostrr.net',
    'https://results.ue1dev2.rostrr.net',
  ],
});

// this works as per documentation
//@ts-expect-error this works
//eslint-disable-next-line import/no-unresolved
import { registerSW } from 'virtual:pwa-register';
registerSW({});

// polyfills
import './polyfils/setSymmetricDifference.polyfill.ts';
import './polyfils/setDifference.polyfill.ts';
// @todo This code needs to be removed after resolving https://fastnorth.atlassian.net/browse/RV-8783
import './polyfils/resizeObserverWorkaroud.polyfill.ts';
import { createRoot } from 'react-dom/client';
import './i18n/init';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import ErrorBoundary from './views/error/ErrorBoundary';
import TranslatedCookieConsentBanner from './components/cookie-consent/TranslatedCookieConsent.tsx';

const container = document.getElementById('karwa-app') as Element;
(() => {
  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <RouterProvider router={router} />
      <TranslatedCookieConsentBanner />
    </ErrorBoundary>
  );
})();
